// extractGraphMetricsRows : portfolio graph metrics responses use { data, aggregates }
export function extractGraphMetricsRows(raw) {
    if (Array.isArray(raw?.data)) {
        return raw.data;
    }
    if (Array.isArray(raw)) {
        return raw;
    }
    if (Array.isArray(raw?.points)) {
        return raw.points;
    }
    return [];
}

export function extractGraphMetricsAggregates(raw) {
    if (!raw?.aggregates || typeof raw.aggregates !== 'object') {
        return null;
    }
    return raw.aggregates;
}

// normalizeHourGraphPayload : normalize hourly data point graph payload data from the API
export function normalizeHourGraphPayload(raw) {
    const rows = extractGraphMetricsRows(raw);
    return rows
      .map(row => {
        const t = row.date ?? row.time ?? row.timestamp ?? row.t;
        const v = row.value ?? row.right ?? row.power_mw ?? row.y ?? row.mwh;
        const date = t != null ? new Date(t) : null;
        const value = v != null ? Number(v) : NaN;
        const point = { date, value };
        const valueMin = row.valueMin != null ? Number(row.valueMin) : NaN;
        const valueMax = row.valueMax != null ? Number(row.valueMax) : NaN;
        if (Number.isFinite(valueMin)) point.valueMin = valueMin;
        if (Number.isFinite(valueMax)) point.valueMax = valueMax;
        return point;
      });
}

// normalizeDayGraphPayload : normalize daily data point graph payload data from the API
export function normalizeDayGraphPayload(raw, type = 'grid') {
    const rows = extractGraphMetricsRows(raw);
    return rows
        .map(row => {
            const t = row.date ?? row.key;
            const date = t != null ? new Date(t) : null;
            const dayLabel = row.dayLabel ?? "";
            const dateLabel = row.dateLabel ?? "";
            const key = date.toISOString().slice(0, 10);
            let result = { key, date, dayLabel, dateLabel };

            if(type === 'solar') {
                result.value = row.value != null ? Number(row.value) : NaN;
            } else {
              result.pos = row.pos != null ? Number(row.pos) : NaN;
              result.neg = row.neg != null ? Number(row.neg) : NaN;
            }

            return result;
        });
}